export interface SpritesMap {
	sprite:
		| 'apple-icon'
		| 'arrow-down-icon'
		| 'chevron-down-icon'
		| 'chevron-up-icon'
		| 'clock-icon'
		| 'close-icon'
		| 'copy-icon'
		| 'delete-icon'
		| 'dismiss-icon-transparent'
		| 'dismiss-icon'
		| 'edit-icon'
		| 'edit-pencil-icon'
		| 'exclamation-mark-icon'
		| 'google-icon'
		| 'left-arrow'
		| 'mark-icon'
		| 'mark-simple-icon'
		| 'offer-package-icon'
		| 'order-duration'
		| 'question-mark-tooltip'
		| 'racing-flag'
		| 'right-arrow'
		| 'save-icon'
		| 'search-icon'
		| 'select-arrow'
		| 'straight-racing-flag'
		| 'ticket'
		| 'wallet-icon';
}
export const SPRITES_META: {
	[Key in keyof SpritesMap]: {
		filePath: string;
		items: Record<
			SpritesMap[Key],
			{
				viewBox: string;
			}
		>;
	};
} = {
	sprite: {
		filePath: 'sprite.75524cd2.svg',
		items: {
			'apple-icon': {
				viewBox: '0 0 19 21',
			},
			'arrow-down-icon': {
				viewBox: '0 0 20 20',
			},
			'chevron-down-icon': {
				viewBox: '0 0 24 24',
			},
			'chevron-up-icon': {
				viewBox: '0 0 24 24',
			},
			'clock-icon': {
				viewBox: '0 0 10 12',
			},
			'close-icon': {
				viewBox: '0 0 24 24',
			},
			'copy-icon': {
				viewBox: '0 0 24 24',
			},
			'delete-icon': {
				viewBox: '0 0 24 24',
			},
			'dismiss-icon-transparent': {
				viewBox: '0 0 14 14',
			},
			'dismiss-icon': {
				viewBox: '0 0 21 20',
			},
			'edit-icon': {
				viewBox: '0 0 24 24',
			},
			'edit-pencil-icon': {
				viewBox: '0 0 24 24',
			},
			'exclamation-mark-icon': {
				viewBox: '0 0 20 20',
			},
			'google-icon': {
				viewBox: '0 0 48 48',
			},
			'left-arrow': {
				viewBox: '0 0 16 16',
			},
			'mark-icon': {
				viewBox: '0 0 24 24',
			},
			'mark-simple-icon': {
				viewBox: '0 0 16 16',
			},
			'offer-package-icon': {
				viewBox: '0 0 24 25',
			},
			'order-duration': {
				viewBox: '0 0 10 12',
			},
			'question-mark-tooltip': {
				viewBox: '0 0 32 32',
			},
			'racing-flag': {
				viewBox: '0 0 18 24',
			},
			'right-arrow': {
				viewBox: '0 0 16 16',
			},
			'save-icon': {
				viewBox: '0 0 24 24',
			},
			'search-icon': {
				viewBox: '0 0 21 20',
			},
			'select-arrow': {
				viewBox: '0 0 9 6',
			},
			'straight-racing-flag': {
				viewBox: '0 0 9 10',
			},
			ticket: {
				viewBox: '0 0 20 16',
			},
			'wallet-icon': {
				viewBox: '0 0 20 16',
			},
		},
	},
};
